import React from 'react';
import { Button, Modal, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isValueEntered, isNameValid } from 'services/Validation';

class SecurityAdd extends React.Component {
    constructor(props) {
        super(props);

        const { id, orgid, thumb, name, key, url, account, selected, starred, frequently } = props.security;
        this.state = {
            id,
            orgid,
            thumb,
            name,
            key,
            url,
            account,
            selected,
            starred,
            frequently,
            nameValid: isNameValid(name),
            keyValid: isValueEntered(key),
            urlValid: isValueEntered(url),
            accountValid: isValueEntered(account),
            formErrors: { name: '', key: '', url: '', account: '' },
            formValid: false,
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let nameValid = this.state.nameValid;
        let keyValid = this.state.keyValid;
        let urlValid = this.state.urlValid;
        let accountValid = this.state.accountValid;

        switch (fieldName) {
            case 'name':
                nameValid = isNameValid(value);
                fieldValidationErrors.name = nameValid ? '' : ' is invalid';
                break;
            case 'key':
                keyValid = isValueEntered(value);
                fieldValidationErrors.key = keyValid ? '' : ' is invalid';
                break;
            case 'url':
                urlValid = isValueEntered(value);
                fieldValidationErrors.url = urlValid ? '' : ' is invalid';
                break;
            case 'account':
                accountValid = isValueEntered(value);
                fieldValidationErrors.account = accountValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            nameValid: nameValid,
            keyValid: keyValid,
            urlValid: urlValid,
            accountValid: accountValid,
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.nameValid && this.state.keyValid && this.state.urlValid && this.state.accountValid });
    }

    render() {
        const { onSaveSecurity, showSecurityLoader, onSecurityClose, open, security } = this.props;
        const { id, orgid, name, key, url, account, selected, starred, frequently } = this.state;
        const isNew = security.name === '';
        let { thumb } = this.state;
        return (
            <Modal className="modal-box" toggle={onSecurityClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    {isNew ? <IntlMessages id="security.addSecurity" /> :
                        <IntlMessages id="security.saveSecurity" />}
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onSecurityClose} />
                    </span>
                </ModalHeader>

                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <div className="col-lg-3 text-center text-lg-right order-lg-2">
                            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={thumb} />
                        </div>

                        <div className="panel panel-default">
                            <FormErrors formErrors={this.state.formErrors} />
                        </div>

                        <div className="col-lg-9 d-flex flex-column order-lg-1">
                            <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                            <input id="name" type="text" className={`form-control mb-2 ${name ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={name} name="name"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.key" />}</h3>
                            <input id="key" type="text" className={`form-control mb-2 ${key ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={key} name="key"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.url" />}</h3>
                            <input id="url" type="text" className={`form-control mb-2 ${url ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleUserInput(event)}
                                value={url} name="url"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.account" />}</h3>
                            <input id="account" type="text" className={`form-control mb-2 ${account ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleUserInput(event)}
                                value={account} name="account"
                            />
                        </div>
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                        showSecurityLoader();
                        onSecurityClose();
                        onSaveSecurity(
                            {
                                'id': id,
                                'orgid': orgid,
                                'name': name,
                                'key': key,
                                'url': url,
                                'account': account,
                                'thumb': null,
                                'selected': selected,
                                'starred': starred,
                                'frequently': frequently,
                            });
                        this.setState({
                            id: '',
                            orgid: '',
                            name: '',
                            key: '',
                            url: '',
                            account: '',
                            thumb: null,
                            selected: false,
                            starred: false,
                            frequently: false,
                            formErrors: { name: '', key: '', url: '', account: '' },
                            formValid: false,
                        });

                    }}>
                        {isNew ? <IntlMessages id="security.addSecurity" /> :
                            <IntlMessages id="security.saveSecurity" />}</Button>
                </div>
            </Modal>
        );
    }
}

export default SecurityAdd;


// WEBPACK FOOTER //
// ./components/Agile/security/securityAdd/index.js